import Navbar from "../../components/navbar/Navbar"
import Sidebar from "../../components/sidebar/Sidebar"
import Reports from "./reportsTable"

const ReportsContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <Reports />
      </div>
    </div>
  )
}

export default ReportsContainer